<template>
  <div v-if="visivel" class="lote-modal-overlay" @click.self="$emit('fechar')">
    <div class="lote-modal">
      <div class="lote-modal__header">
        <h3 class="lote-modal__title">
          <i class="fas fa-tag"></i>
          Selecionar Lote
        </h3>
        <button class="lote-modal__close" @click="$emit('fechar')">×</button>
      </div>

      <div v-if="produto" class="lote-modal__produto">
        <span class="lote-modal__produto-nome">{{ produto.descricao }}</span>
        <span class="lote-modal__produto-qtd">Quantidade solicitada: <strong>{{ quantidade }}</strong></span>
      </div>

      <div v-if="!lotes || lotes.length === 0" class="lote-modal__vazio">
        <i class="fas fa-exclamation-circle"></i>
        Nenhum lote disponível em estoque para este produto.
      </div>

      <div v-else class="lote-modal__tabela-wrap">
        <table class="lote-modal__tabela">
          <thead>
            <tr>
              <th>Nº Lote</th>
              <th>Fabricação</th>
              <th>Validade</th>
              <th>Disponível</th>
              <th>Usar</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="lote in lotes"
              :key="lote.id_produto_lote"
              :class="{ 'lote-modal__row--selecionado': loteSelecionadoId === lote.id_produto_lote }"
              @click="selecionarLote(lote)"
            >
              <td>{{ lote.numero_lote || '—' }}</td>
              <td>{{ formatarData(lote.data_fabricacao) }}</td>
              <td :class="{ 'lote-modal__vencido': isVencido(lote.data_validade) }">
                {{ formatarData(lote.data_validade) }}
                <span v-if="isVencido(lote.data_validade)" class="lote-modal__badge-vencido">Vencido</span>
              </td>
              <td>{{ lote.quantidade }}</td>
              <td>
                <input
                  v-if="loteSelecionadoId === lote.id_produto_lote"
                  v-model.number="qtdUsar"
                  type="number"
                  min="0.001"
                  :max="lote.quantidade"
                  step="0.001"
                  class="lote-modal__qty-input"
                  @click.stop
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="erro" class="lote-modal__erro">
        <i class="fas fa-exclamation-circle"></i> {{ erro }}
      </div>

      <div class="lote-modal__footer">
        <button class="lote-modal__btn lote-modal__btn--cancel" @click="$emit('fechar')">
          Cancelar
        </button>
        <button
          class="lote-modal__btn lote-modal__btn--confirm"
          :disabled="!loteSelecionado || qtdUsar <= 0"
          @click="confirmar"
        >
          <i class="fas fa-check"></i> Confirmar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoteProdutoModalPdv",

  props: {
    visivel:    { type: Boolean, default: false },
    produto:    { type: Object,  default: null },
    lotes:      { type: Array,   default: () => [] },
    quantidade: { type: Number,  default: 1 },
  },

  data() {
    return {
      loteSelecionadoId: null,
      qtdUsar: 1,
      erro: "",
    };
  },

  computed: {
    loteSelecionado() {
      if (!this.loteSelecionadoId) return null;
      return this.lotes.find((l) => l.id_produto_lote === this.loteSelecionadoId) ?? null;
    },
  },

  watch: {
    visivel(val) {
      if (val) {
        this.loteSelecionadoId = null;
        this.qtdUsar = this.quantidade;
        this.erro = "";
        // Auto-seleciona se há apenas um lote
        if (this.lotes && this.lotes.length === 1) {
          this.selecionarLote(this.lotes[0]);
        }
      }
    },
    quantidade(val) {
      this.qtdUsar = val;
    },
  },

  methods: {
    selecionarLote(lote) {
      this.loteSelecionadoId = lote.id_produto_lote;
      this.qtdUsar = Math.min(this.quantidade, lote.quantidade);
      this.erro = "";
    },

    confirmar() {
      this.erro = "";

      if (!this.loteSelecionado) {
        this.erro = "Selecione um lote.";
        return;
      }

      const qtd = Number(this.qtdUsar);
      if (!qtd || qtd <= 0) {
        this.erro = "Informe uma quantidade válida.";
        return;
      }

      if (qtd > this.loteSelecionado.quantidade) {
        this.erro = `Quantidade informada (${qtd}) excede o saldo do lote (${this.loteSelecionado.quantidade}).`;
        return;
      }

      console.log('[LOTE_MODAL] confirmando lote:', {
        loteSelecionado: this.loteSelecionado,
        quantidadeSelecionada: qtd,
      });

      this.$emit("confirmar", this.loteSelecionado, qtd);
    },

    formatarData(dt) {
      if (!dt) return "—";
      try {
        const [ano, mes, dia] = dt.split("T")[0].split("-");
        return `${dia}/${mes}/${ano}`;
      } catch {
        return dt;
      }
    },

    isVencido(data_validade) {
      if (!data_validade) return false;
      try {
        return new Date(data_validade) < new Date();
      } catch {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.lote-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lote-modal {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);
  width: 600px;
  max-width: 95vw;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.lote-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
}

.lote-modal__title {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.lote-modal__close {
  background: none;
  border: none;
  font-size: 1.4rem;
  color: #64748b;
  cursor: pointer;
  line-height: 1;
  padding: 0 0.25rem;
}

.lote-modal__close:hover {
  color: #1e293b;
}

.lote-modal__produto {
  padding: 0.75rem 1.25rem;
  background: #f0f9ff;
  border-bottom: 1px solid #e0f2fe;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
}

.lote-modal__produto-nome {
  font-weight: 600;
  color: #0369a1;
  font-size: 0.9rem;
}

.lote-modal__produto-qtd {
  font-size: 0.85rem;
  color: #475569;
}

.lote-modal__tabela-wrap {
  overflow-y: auto;
  flex: 1;
  padding: 0.5rem;
}

.lote-modal__tabela {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.lote-modal__tabela th {
  background: #f1f5f9;
  padding: 0.5rem 0.75rem;
  text-align: left;
  font-weight: 600;
  color: #64748b;
  border-bottom: 2px solid #e2e8f0;
}

.lote-modal__tabela td {
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #f1f5f9;
  color: #1e293b;
}

.lote-modal__tabela tr {
  cursor: pointer;
}

.lote-modal__tabela tr:hover td {
  background: #f0fdf4;
}

.lote-modal__row--selecionado td {
  background: #dcfce7 !important;
}

.lote-modal__vencido {
  color: #dc2626;
}

.lote-modal__badge-vencido {
  background: #fee2e2;
  color: #dc2626;
  font-size: 0.7rem;
  padding: 1px 5px;
  border-radius: 4px;
  margin-left: 4px;
  font-weight: 600;
}

.lote-modal__qty-input {
  width: 80px;
  border: 1px solid var(--primary-color, #ee7361);
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  outline: none;
}

.lote-modal__vazio {
  padding: 2rem;
  text-align: center;
  color: #64748b;
  font-size: 0.9rem;
}

.lote-modal__erro {
  margin: 0.5rem 1.25rem;
  background: #fee2e2;
  color: #dc2626;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-size: 0.875rem;
}

.lote-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 0.875rem 1.25rem;
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
}

.lote-modal__btn {
  padding: 0.5rem 1.25rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: background 0.15s;
}

.lote-modal__btn--cancel {
  background: #f1f5f9;
  color: #475569;
}

.lote-modal__btn--cancel:hover {
  background: #e2e8f0;
}

.lote-modal__btn--confirm {
  background: #16a34a;
  color: #fff;
}

.lote-modal__btn--confirm:hover:not(:disabled) {
  background: #15803d;
}

.lote-modal__btn--confirm:disabled {
  background: #86efac;
  cursor: not-allowed;
}
</style>
